import { render, staticRenderFns } from "./SignaturesList.vue?vue&type=template&id=058e5dc1&scoped=true&"
import script from "./SignaturesList.vue?vue&type=script&lang=js&"
export * from "./SignaturesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e5dc1",
  null
  
)

export default component.exports